import createReducer from 'reducers/createReducer';

import { Bills } from 'actions/actionTypes';

const INITIAL_STATE = {
    list: [],

    id: 0,
    detail: {
        shopName: '',
        billYear: 0,
        billMonth: 0,
        measurementStartTime: '',
        measurementEndTime: '',
        currency: 'KRW',
        charges: 0,
        vat: 0,
        discountCharges: 0,
        paymentType: '',
        paymentDueTime: '',
        paymentMethod: null,
        paymentInstrument: null,
        orderNumber: null,
        isPaymentSuccess: false,
        paymentSuccessDate: null,
        clients: [],
        invoices: [],

        amountAB: 0,
        vatAB: 0,
    },

    error: {
        triggered: false,
        message: '',
    },
};

// 리듀서
const reducer = createReducer(INITIAL_STATE, {
    [Bills.LOAD_SHOP_BILLS_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;
    },
    [Bills.LOAD_SHOP_BILLS_REQUEST_SUCCESS]: (state, action) => {
        state.list = action.payload.list;
    },
    [Bills.LOAD_SHOP_BILLS_REQUEST_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload,
        };
    },

    [Bills.LOAD_SHOP_BILLS_DETAIL_REQUEST]: (state, action) => {
        state.error = INITIAL_STATE.error;

        state.id = action.payload;
    },
    [Bills.LOAD_SHOP_BILLS_DETAIL_REQUEST_SUCCESS]: (state, action) => {
        state.detail.shopName = action.payload.shopName;
        state.detail.billYear = action.payload.billYear;
        state.detail.billMonth = action.payload.billMonth;
        state.detail.measurementStartTime = action.payload.measurementStartTime;
        state.detail.measurementEndTime = action.payload.measurementEndTime;
        state.detail.currency = action.payload.currency;
        state.detail.charges = action.payload.charges;
        state.detail.vat = action.payload.vat;
        state.detail.discountCharges = action.payload.discountCharges;
        state.detail.paymentType = action.payload.paymentType;
        state.detail.paymentDueTime = action.payload.paymentDueTime;
        state.detail.paymentMethod = action.payload.paymentMethod;
        state.detail.paymentInstrument = action.payload.paymentInstrument;
        state.detail.orderNumber = action.payload.orderNumber;
        state.detail.isPaymentSuccess = action.payload.isPaymentSuccess;
        state.detail.paymentSuccessTime = action.payload.paymentSuccessTime;
        state.detail.clients = action.payload.clients;
        state.detail.invoices = action.payload.invoices;

        state.detail.amountAB = action.payload.charges - action.payload.discountCharges;
        state.detail.vatAB = action.payload.vat - 0;

        state.detail.totalAmount = action.payload.charges + action.payload.vat - action.payload.discountCharges;
    },
    [Bills.LOAD_SHOP_BILLS_DETAIL_REQUEST_FAILURE]: (state, action) => {
        state.error = {
            triggered: true,
            message: action.payload,
        };
    },
});

export default reducer;
